// Due UIKIT issues
export const forceModalClose = () => {
  document.querySelectorAll('.modal').forEach((modal) => {
    modal.classList.remove('show');
  });
};
